// Helper: Remove highlights from an element safely
function removeHighlights (element) {
    element.querySelectorAll('mark.highlight').forEach(mark => {
        mark.parentNode.replaceChild(document.createTextNode(mark.textContent), mark);
    });

    element.normalize();
};

// Helper: Highlight text in an element safely (preserving HTML structure)
function highlightTextInElement(element, query) {
    if (!element.textContent.toLowerCase().includes(query.toLowerCase())) {
        return false;
    }

    let escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    let regex = new RegExp(`(${escapeRegExp(query)})`, 'gi');

    let hasMatch = false;
    let walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        {
            acceptNode: (node) => {
                // Skip empty nodes or nodes that are already inside a highlight
                if (!node.nodeValue.trim() || node.parentNode.classList.contains('highlight')) {
                    return NodeFilter.FILTER_REJECT;
                }
                return NodeFilter.FILTER_ACCEPT;
            }
        }
    );

    let textNodes = [];
    while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
    }

    textNodes.forEach(node => {
        let text = node.nodeValue;
        regex.lastIndex = 0;

        if (regex.test(text)) {
            hasMatch = true;
            let fragment = document.createDocumentFragment();
            let lastIndex = 0;

            regex.lastIndex = 0;
            let match;

            while ((match = regex.exec(text)) !== null) {
                let start = match.index;
                let end = start + match[0].length;

                if (start > lastIndex) {
                    fragment.appendChild(document.createTextNode(text.slice(lastIndex, start)));
                }

                let mark = document.createElement('mark');
                mark.className = 'highlight';
                mark.textContent = match[0];
                fragment.appendChild(mark);

                lastIndex = end;
            }

            if (lastIndex < text.length) {
                fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
            }

            node.parentNode.replaceChild(fragment, node);
        }
    });

    return hasMatch;
};

function setShowMoreButtonVisibility(showMoreButton, visibility) {
    if (visibility) {
        showMoreButton.style.display = 'block';
        document.querySelector('#' + showMoreButton.getAttribute('for')).checked = false;

        return;
    }

    showMoreButton.style.display = 'none';
    document.querySelector('#' + showMoreButton.getAttribute('for')).checked = true;
}

function handleCardVisibility(card) {
    card.style.display = null !== card.querySelector('.maier-section-cards-list-item-elements-list-item:not(.maier-section-cards-list-item-elements-list-item-hidden)') ? 'flex' : 'none';
}

function setCardElementVisibility(cardElement, visibility) {
    if (cardElement.classList.contains('maier-section-cards-list-item-elements-list-item-hidden') && visibility) {
        cardElement.classList.remove('maier-section-cards-list-item-elements-list-item-hidden');
    }

    if (!cardElement.classList.contains('maier-section-cards-list-item-elements-list-item-hidden') && !visibility) {
        cardElement.classList.add('maier-section-cards-list-item-elements-list-item-hidden');
    }
}

function initSearchField() {
    let searchInputElement = document.querySelector('.maier-section-cards-search-input');
    if (null === searchInputElement) {
        return;
    }

    let searchCountElement = document.querySelector('.maier-section-cards-search-count');
    let items = document.querySelectorAll('.maier-section-cards-list-item-elements-list-item');

    searchInputElement.addEventListener('input', function() {
        let query = this.value.trim();
        let matchCount = 0;

        items.forEach(item => {
            let checkbox = item.querySelector('input[type="checkbox"]');
            let title = item.querySelector('label.maier-section-cards-list-item-elements-list-item-title');
            let desc = item.querySelector('p.maier-section-cards-list-item-elements-list-item-description');
            let card = item.parentElement.parentElement;
            let showMoreButton = card.querySelector('.maier-section-cards-list-item-action-show-more');

            if (query.length < 3) {
                searchCountElement.style.display = 'none';
                checkbox.checked = false;
                removeHighlights(title);
                removeHighlights(desc);
                setCardElementVisibility(item, true);
                handleCardVisibility(card);

                if (null !== showMoreButton) {
                    setShowMoreButtonVisibility(showMoreButton, true);
                }

                return;
            }

            checkbox.checked = false;
            removeHighlights(title);
            if (highlightTextInElement(title, query)) {
                checkbox.checked = true;
                matchCount++;
            }

            removeHighlights(desc);
            if (highlightTextInElement(desc, query)) {
                checkbox.checked = true;
                matchCount++;
            }

            setCardElementVisibility(item, checkbox.checked);
            handleCardVisibility(card);
            if (null !== showMoreButton) {
                setShowMoreButtonVisibility(showMoreButton, false);
            }
        });

        if (query.length > 2) {
            searchCountElement.style.display = 'block';
            searchCountElement.querySelector('.maier-section-cards-search-count-match').textContent = matchCount;
            searchCountElement.querySelector('.maier-section-cards-search-count-query').textContent = query;
        }
    });
}

function initShowMoreFields() {
    document.querySelectorAll('.maier-section-cards-list-item-action-show-more').forEach(function (element) {
        element.addEventListener('click', function () {
            this.style.display = 'none';
        })
    })
}

function setupMaierSectionCards() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            initSearchField();
            initShowMoreFields();
        })
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMaierSectionCards);
} else {
    setupMaierSectionCards();
}